module.exports = __webpack_public_path__ + "static/media/pathSecondLight.95cbc9da.svg";